import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import useUser from '../hooks/global/useUser';
import { LoadedUser } from '../interfaces';
import useListOffboardings from '../hooks/offboardings/useListOffboardings';
import OffboardingWizard from '../components/offboarding/OffboardingWizard';
import { isUserAdminOrManager } from '../utils/global/helper';
import { ROUTES } from '../constants/global';
import { getFullName } from '../helpers/global';

export default function OffboardWizardPage() {
  const { user: loadedUser } = useUser<LoadedUser>();
  const { employeeId } = useParams<{ employeeId: string }>();

  const businessId = loadedUser?.business.id;

  const employee = React.useMemo(
    () => loadedUser?.business.employees.find(e => e.employeeId === employeeId),
    [employeeId, loadedUser?.business.employees],
  );

  const { data: offboardings, isLoading: isLoadingOffboardings } =
    useListOffboardings(
      {
        businessId: businessId ?? '',
        employeeId,
        pendingOnly: true,
      },
      { enabled: !!businessId && !!employeeId },
    );

  const existingOffboarding = offboardings?.[0] ?? null;

  if (!loadedUser) return null;
  if (!isUserAdminOrManager(loadedUser))
    return <Navigate to={ROUTES.team} replace />;
  if (!employeeId || !employee) return <Navigate to={ROUTES.team} replace />;
  if (isLoadingOffboardings) return null;

  const employeeName =
    employee.displayName ||
    getFullName({
      firstName: employee.user?.firstName,
      lastName: employee.user?.lastName,
    }) ||
    'this artist';

  const isSelf = employeeId === loadedUser.employee.employeeId;

  return (
    <OffboardingWizard
      key={employeeId}
      businessId={loadedUser.business.id}
      employeeId={employeeId}
      employeeName={employeeName}
      isSelf={isSelf}
      existingOffboarding={existingOffboarding}
    />
  );
}
